import React from "react";
import { ExclamationCircleIcon } from "@heroicons/react/solid";
import InlineLoader from "../../components/loader/InlineLoader";
import { Button } from "../../components/ui";

const NeedsAttentionMessage = ({
  time,
  sent = true,
  isResolved = false,
  status = null,
  message,
  isOptimistic = false,
  failed = false,
  messageId,
  onResolve,
  onRevoke,
}) => {
  // Determine if resolved based on the status from API
  const isResolvedFromApi = status === "resolve" || status === "revoke";

  return (
    <div
      className={`
      ${sent ? "self-end" : "self-start"} 
      p-4 px-5 rounded-lg max-w-[80%] relative shadow-md
      ${failed ? "border border-red-500" : ""}
      ${isOptimistic ? "opacity-70" : ""}
      ${
        isResolvedFromApi
          ? "bg-gray-100"
          : sent
          ? "bg-red-50 border border-red-200"
          : "bg-orange-50 border border-orange-200"
      }
    `}
    >
      <div className="flex items-center">
        <ExclamationCircleIcon
          className={`w-6 h-6 ${
            isResolvedFromApi
              ? "text-gray-400"
              : sent
              ? "text-red-500"
              : "text-orange-500"
          } mr-2`}
        />
        <div className="flex-1">
          <p
            className={`font-medium ${
              isResolvedFromApi
                ? "text-gray-500"
                : sent
                ? "text-red-600"
                : "text-orange-600"
            }`}
          >
            {isResolvedFromApi
              ? status === "resolve"
                ? "Attention Request Resolved"
                : "Attention Request Revoked"
              : sent
              ? "Needs Urgent Attention!"
              : "Requesting Your Attention"}
          </p>
          <p
            className={`text-sm ${
              isResolvedFromApi
                ? "text-gray-500"
                : sent
                ? "text-red-600"
                : "text-orange-600"
            }`}
          >
            {message ||
              (isResolvedFromApi
                ? status === "resolve"
                  ? "This request has been resolved."
                  : "This request has been revoked."
                : sent
                ? "I need your immediate attention on this matter."
                : "This person needs your immediate attention.")}
          </p>
        </div>
      </div>

      <div className="flex justify-between items-center mt-3">
        <div className="flex items-center">
          <p className="text-xs text-gray-500">{time}</p>
          {isOptimistic && (
            <span className="ml-2 inline-flex items-center">
              <InlineLoader className="w-3 h-3 text-gray-400" />
            </span>
          )}
          {failed && (
            <span className="ml-2 text-xs text-red-500">Failed to send</span>
          )}
        </div>

        {/* Show action buttons only if the message is not resolved/revoked and not optimistic */}
        {!isResolvedFromApi && !isOptimistic && !failed && (
          <div className="flex space-x-2">
            {/* Show Resolve button for both sent and received messages */}
            <Button
              onClick={() => onResolve && onResolve(messageId)}
              className="border rounded-full text-sm transition-colors text-white border-green-700 bg-green-500 hover:bg-green-600"
            >
              Resolve
            </Button>

            {/* Show Revoke button only for sent messages */}
            {sent && (
              <Button
                onClick={() => onRevoke && onRevoke(messageId)}
                className="border rounded-full text-sm hover:bg-opacity-10 transition-colors bg-white text-red-600 border-red-300 hover:bg-red-100"
              >
                Revoke
              </Button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default NeedsAttentionMessage;
